import { getSiblingsForBlock } from "app/regions/utils/block-traversal"

export function getFriendlySectionLabel(block, blocks) {
  const siblings = getSiblingsForBlock(block.block_id, blocks)

  if (block.order === 0) {
    return "Header"
  } else if (block.order === siblings.length - 1) {
    return "Footer"
  } else {
    return "Body"
  }
}
